import React, { useState, useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { CircularProgress } from '@material-ui/core'
import { connect } from 'react-redux'
import actions from '../reducers/actions'
import { getTitle } from '../utils'

function PrivateRoutes(props) {
  const { user, data, getUserInfo, getVendors, getCrews, getUsers, getEvents } = props
  
  document.title = getTitle()
  const [fetching, setFetching] = useState(true)
  
  const fetchData = () => {
    const promises = []
    if (!user.vendors.length) promises.push(getVendors(user))
    if (!user.crews.length) promises.push(getCrews(user))
    if (!user.users.length) promises.push(getUsers(user))
    if (!data.events.length) promises.push(getEvents(user))
    return Promise.all(promises)
  }
  
  useEffect(() => {
    if (!user.isAuthenticated) {
      getUserInfo(user)
        .then(fetchData)
        .catch(console.error)
        .finally(() => setFetching(false))
    } else {
      fetchData()
        .catch(console.error)
        .finally(() => setFetching(false))
    }
  }, [])
  
  return fetching
    ? <CircularProgress style={{ marginLeft: '48%' }}/>
    : user.isAuthenticated
      ? <Route {...props} />
      : <Redirect to='/login'/>
}

const mapStateToProps = (state, ownProps) => {
  return { ...state, ...ownProps }
}

export default connect(mapStateToProps, actions)(PrivateRoutes)